import React from "react";
import styles from "./NewRestaurants.module.scss";
import ButtonWithIcon from "../ButtonWithIcon/ButtonWithIcon";

const NewRestaurant = ({ title, card, booking, imageLeft, imageRight }) => {
  return (
    <div className={styles.OurRestaurants}>
      <div className={styles.title}>{}</div>
      <div className={styles.box}>
        <div className={`${styles.littleBox} ${styles.topSquares} section_one`}>
          <div className={styles.text}>
            <div className={styles.sectionTitle}>
              <span>{card[0].title}</span>
            </div>
            <div className={styles.name}>{card[0].author}</div>
            <div className={styles.subtitle}>{card[0].subtitle}</div>
            <div dangerouslySetInnerHTML={{ __html: card[0].text }}></div>
            <div className={styles.boxButtons}>
              {card[0].links && card[0].links.length && 
                card[0].links.map( (item, ind) => <ButtonWithIcon key={'link-'+ind} link={item.link} outline={true} />)
              }
            </div>
          </div>
        </div>
        <div
          className={`${styles.littleBox} ${styles.black} ${styles.lineRight} ${styles.topSquares} bigSection_one`}
        >
          <div className={styles.textBlack}>
            <div className={styles.titleRight}>{card[1].title}</div>
            <div className={styles.subtitle}>{card[1].subtitle}</div>
            <div dangerouslySetInnerHTML={{ __html: card[1].text }}></div>
          </div>
        </div>
      </div>
      <div className={styles.box}>
        <img src={imageLeft.src} alt={imageLeft.alt} className="bigSection_two"></img>
        <img src={imageRight.src} alt={imageRight.alt} className="bigSection_one"></img>
      </div>
      {card.length > 2 &&
      <div className={styles.box} >
        <div
          className={`${styles.littleBox} ${styles.black} ${styles.lineLeft} bigSection_two`}
        >
          <div className={styles.textBlack}>
            <div className={`${styles.sectionTitle} ${styles.white}`}>
              {card[2].title}
            </div>
            <div className={styles.subtitle}>{card[2].subtitle}</div>
            <div dangerouslySetInnerHTML={{ __html: card[2].text }}></div>
          </div>
        </div>
        <div className={styles.littleBox + " section_two"}>
          <div className={styles.cardBox}>
            <div className={styles.sectionTitle}>
              {booking.title}
            </div>
            <div className={styles.card}>
              <div className={styles.opening}>
                <div className={styles.openingTitle}>
                  {booking.opening.title}
                </div>
                <div className={styles.hours}>{booking.opening.subtitle}</div>
                {booking.opening.text}
              </div>
              {booking.links.map((d, i) => (
                <a
                  className={styles.link}
                  key={i}
                  href={d.url}
                  target={d.target}
                >
                  {d.title}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      }

    </div>
  );
};

export default NewRestaurant;
